import { render } from "./MainHome.vue?vue&type=template&id=dade4dd0&bindings={}"
import script from "./MainHome.vue?vue&type=script&lang=js"
export * from "./MainHome.vue?vue&type=script&lang=js"

import "../../vendors/css/bootstrap.css?vue&type=style&index=0&lang=css"
import "../../vendors/fontawesome-free/css/all.min.css?vue&type=style&index=1&lang=css"
import "./MainHome.vue?vue&type=style&index=2&lang=css"
script.render = render

export default script